// 관리자 첫 화면 카드 — 처리위탁 계약 동의 기록이 없거나 옛 판인 업체의 대표에게 한 번 동의를 받는다(막지는 않는다, F3). 동의 기록은 서버(acceptDpa)가 적는다
import { useState } from "react";
import { useOrgStore } from "@/store/org";
import { useAuth } from "@/store/auth";
import { acceptDpa, DPA_URL, DPA_VERSION } from "@/lib/dpa";
import { plainError } from "@/lib/plainError";

export default function DpaConsentCard() {
  const org = useOrgStore((s) => s.org);
  const { user } = useAuth();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [done, setDone] = useState(false);
  if (!org || !user) return null;
  if (org.dpaConsent?.version === DPA_VERSION && !done) return null;
  // 대표만 동의한다(대표 미지정 업체는 관리자 누구나 — 서버 requireOrgOwner와 같은 기준)
  const isOwner = !org.createdBy || org.createdBy === user.uid;
  if (!isOwner) return null;
  if (done) return <div className="card p-4 text-sm text-emerald-700">✅ 개인정보 처리위탁 계약에 동의했습니다. 동의 시각과 계정이 기록되었습니다.</div>;

  const agree = async () => {
    if (!checked || busy) return;
    setBusy(true);
    setMsg("");
    try {
      await acceptDpa();
      setDone(true);
    } catch (e) {
      setMsg(`동의를 저장하지 못했습니다 — ${plainError(e)}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card p-4 border border-sky-300 bg-sky-50 space-y-2 text-sm">
      <div className="font-bold text-sky-900">📄 개인정보 처리위탁 계약에 동의해 주세요{org.dpaConsent ? " — 계약서가 바뀌었습니다" : ""}</div>
      <p className="text-sky-900">
        학생·보호자 정보는 사장님 업체의 정보이고 콕소프트가 맡아 처리합니다. 맡기는 범위, 보호조치, 다시 맡기는 곳(구글·Solapi·카카오·Anthropic·토스페이먼츠), 파기 시점을 계약서로 정합니다. 지금 쓰시는 기능은 그대로 됩니다.{" "}
        <a className="underline font-semibold" href={DPA_URL} target="_blank" rel="noreferrer">계약서 전문 보기</a>
      </p>
      <label className="flex items-start gap-2 cursor-pointer">
        <input type="checkbox" className="mt-1" checked={checked} onChange={(e) => setChecked(e.target.checked)} />
        <span>개인정보 처리위탁 계약서(버전 {DPA_VERSION})를 읽었고 동의합니다(다시 맡기는 곳에 대한 동의 포함).</span>
      </label>
      {msg && <div className="text-red-600">{msg}</div>}
      <button className="btn-primary" onClick={agree} disabled={!checked || busy}>{busy ? "저장 중…" : "동의합니다"}</button>
    </div>
  );
}
